var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106.3 128",
    style: {
      enableBackground: "new 0 0 106.3 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u067E\u06CC\u0634\u062E\u0648\u0627\u0646") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,76.6v11.7c0,2.9-2.4,5.3-5.3,5.3c0,0,0,0,0,0h-7c-2.9,0-5.3,2.4-5.3,5.3l0,0v23.8c0,2.9-2.4,5.3-5.3,5.3 H23.2c-2.9,0-5.3-2.4-5.3-5.3l0,0V98.9c0-2.9-2.4-5.3-5.3-5.3h0H5.3c-2.9,0-5.3-2.4-5.3-5.3c0,0,0,0,0,0V76.6c0-2.9,2.4-5.3,5.3-5.3 l0,0H101C103.9,71.3,106.3,73.7,106.3,76.6L106.3,76.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.3,60.4c0,1.2-0.1,2.4-0.2,3.5h-60c-0.1-1.2-0.2-2.4-0.2-3.5c0-8.9,3.9-17.4,10.8-23.1 c1.6-1.3,3.9-1.3,5.5-0.1c8.6,6.2,20.3,5.9,28.7-0.6c1.2-0.9,2.8-0.9,4,0.1C79.1,42.4,83.3,51.1,83.3,60.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.9,18.6c0,10.3-8.3,18.6-18.6,18.6s-18.6-8.3-18.6-18.6S43,0,53.3,0C63.5,0,71.9,8.3,71.9,18.6 C71.9,18.5,71.9,18.6,71.9,18.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.3779182f752ff75eb27856dd7a229aa8.svg";
export { ForwardRef as ReactComponent };